import { isDesigner } from "@src/utils/refer_context/formatter";
import ReferInput from "../ReferInput";
import { useEffect } from "react";
import { PAGE_MOD_ADD } from '../../utils/constants'
import { observer } from "mobx-react";
import { getUserDeptInfo } from "@src/services";

const UserReferInput = (props) => {
  // const defaultProps = {
  //   refCode: "bip-usercenter.bip_user_ref",
  //   refEntityUri: "base.user.BipUser",
  //   refReturn: ["name"],
  //   refReturnArr: '{ "name": "formStore,name_name" , "id": "formStore,name" }',
  // };
  const { defaultValueType, pageStore } = props;
  const isAdd = pageStore?.status?.toUpperCase() === PAGE_MOD_ADD;
  // { value: "1", text: "当前用户" },
  // { value: "2", text: "制单部门负责人" },
  // { value: "3", text: "制单人上级主管" },
  // { value: "4", text: "制单人上级部门负责人" },
  if (!isDesigner(props) && isAdd) {

    useEffect(async () => {
      if (defaultValueType) {
        const { data: res } = await getUserDeptInfo();
        if (res.code === "0") {
          let data = null
          if (defaultValueType === "1") {
            data = { id: res.data.id, name: res.data.name }
          } else if (defaultValueType === "2") {
            data = { id: res.data.deptPrincipalId, name: res.data.deptPrincipalName }
          } else if (defaultValueType === "3") {
            data = { id: res.data.superSupervisorId, name: res.data.superSupervisorName }
          } else if (defaultValueType === "4") {
            data = { id: res.data.parentDeptPrincipalId, name: res.data.parentDeptPrincipalName }
          }
          if (props.selectType === "multiple") {
            data = [data]
          }
          props.onChange(data)
        }
      }
    }, [defaultValueType]);
  }
  // eslint-disable-next-line react/react-in-jsx-scope
  return <ReferInput {...props} ></ReferInput>;
};
export default observer(UserReferInput);
